import { DatePivotParams } from "../../entities/date_pivot_params";

// Like demand_walk_single's args, plus an explicit `grain` (month | week) derived
// from `date_field`, which the demand_plan_editable transform treats as authoritative.
export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  const dateField = params.dateHierarchy;
  return {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: dateField,
    grain: dateField && dateField.includes("week") ? "week" : "month",
    group_by_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
    value_field: params.measure ?? "",
  };
};
